<template>
  <div class="home">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'm-home'
}
</script>
<style lang="scss" scoped>
//可视区高
:deep(.visual-area-height) {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  overflow-y: auto;
}
</style>